module.exports = __webpack_public_path__ + "img/ozharvest.2350ce9.png";